export enum EIntegrationStatus {
  ACTIVE = 'active',
  SUSPEND = 'suspend'
}
